import { render, staticRenderFns } from "./DetailsShow.vue?vue&type=template&id=ac9a4624&scoped=true&"
import script from "./DetailsShow.vue?vue&type=script&lang=ts&"
export * from "./DetailsShow.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsShow.vue?vue&type=style&index=0&id=ac9a4624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9a4624",
  null
  
)

component.options.__file = "DetailsShow.vue"
export default component.exports